// SPDX-License-Identifier: AGPL-3.0-or-later

import {notifyAvatarCostumeResolversChanged} from '@app/features/ui/avatars/AvatarCostumeResolvers';
import {
	COLOR_RANDOM_OFFSET_MS,
	COSTUME_RANDOM_PERIOD_MS,
	colorRandomWindow,
	costumeRandomWindow,
} from '@fluxer/constants/src/HalloweenCostumeConstants';

export {
	COLOR_RANDOM_OFFSET_MS,
	COSTUME_RANDOM_PERIOD_MS,
	colorRandomWindow,
	costumeRandomWindow,
	pickFromPool,
} from '@fluxer/constants/src/HalloweenCostumeConstants';

let randomWindowTimer: ReturnType<typeof setTimeout> | null = null;

function msUntilNextRandomTick(now = Date.now()): number {
	const nextCostume = (costumeRandomWindow(now) + 1) * COSTUME_RANDOM_PERIOD_MS;
	const nextColor = (colorRandomWindow(now) + 1) * COSTUME_RANDOM_PERIOD_MS + COLOR_RANDOM_OFFSET_MS;
	return Math.max(1, Math.min(nextCostume, nextColor) - now);
}

export function startCostumeRandomWindowTimer(): void {
	if (randomWindowTimer != null) return;
	const schedule = (): void => {
		randomWindowTimer = setTimeout(() => {
			randomWindowTimer = null;
			notifyAvatarCostumeResolversChanged();
			startCostumeRandomWindowTimer();
		}, msUntilNextRandomTick());
	};
	schedule();
}

export function stopCostumeRandomWindowTimer(): void {
	if (randomWindowTimer == null) return;
	clearTimeout(randomWindowTimer);
	randomWindowTimer = null;
}
